import React  from 'react';
import styled from 'styled-components';
const Styles = styled.div`
  margin: 0.5rem 0;
  .box-stages {
    width: calc(100% - calc(var(--universal-pad) * 2));
    margin: 0 var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    border-radius: var(--border-radius-32);
    position: relative;
    display: grid;
    gap: 0.5rem;
    isolation: isolate;
    &::before {
      z-index: -1;
      content: "";
      position: absolute;
      top: 50px;
      left: 2rem;
      right: 2rem;
      border-bottom: 1px dashed var(--n-grey-2);
    }
    .stage {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1rem 1rem;
      gap: 0.5rem;
      /* max-width: 30%; */
      .icon {
        width: 64px;
        height: 64px;
        border-radius: 100px;
        overflow: hidden;
        background-color: var(--n-grey-0);
        border: 1px solid var(--n-grey-11);
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .title {
        background-color: var(--n-grey-0);
        font-size: 1rem;
        font-weight: 700;
      }
      .desc {
        background-color: var(--n-grey-0);
      }
    }
  }
  @media screen and (max-width: 850px) {
    .box-stages {
      flex-direction: column;
      &::before {
        position: absolute;
        top: 50px;
        bottom: 50px;
        left: 50%;
        right: auto;
        border-right: 1px dashed var(--n-grey-2);
      }
      .stage {
        max-width: none;
      }
    }
  }
`
export default function Stages22 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const makeStages = () => {
    return data.stages.map((v, i) => {
      return (
        <div className='stage'>
          <div className='icon'>
            <img src={v.icon} alt={v.title}/>
          </div>
          <div className='title'>
            {v.title}
          </div>
          <div className='desc'>
            {v.text}
          </div>
        </div>
      )
    })
    
  }
  let cols = data.stages.length;
  if(window.innerWidth < 850){
    cols = 1
  }
  return (
    <Styles>
      <div className='box-stages' style={{gridTemplateColumns: `repeat(${cols},1fr)`}}>
        {makeStages()}
      </div>
    </Styles>
  )
}

